import { useParams, Link, useNavigate } from 'react-router-dom';
import { allSanstha } from '../data/santhaData';
import logo from '../assets/logo.png';
import './SanthaDetail.css';

export default function SanthaDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const sanstha = allSanstha.find((s) => s.id === parseInt(id));

  if (!sanstha) {
    return (
      <div className="detail-not-found">
        <div className="container" style={{ textAlign: 'center', padding: '200px 0 100px' }}>
          <img src={logo} alt="Aarambh" style={{ height: '80px', objectFit: 'contain', marginBottom: '8px' }} />
          <h2>Mandal Not Found</h2>
          <p>We couldn't find this mandal in our directory.</p>
          <Link to="/sanstha" className="btn-primary" style={{ marginTop: '20px', display: 'inline-block' }}>
            ← Back to Directory
          </Link>
        </div>
      </div>
    );
  }

  const isDetailed = !!sanstha.about;

  return (
    <div className="sanstha-detail-page">

      {/* Hero */}
      <div className="detail-hero">
        <div className="container">
          <button className="back-btn" onClick={() => navigate(-1)}>
            ← Back to Directory
          </button>
          <div className="detail-hero-content">
            <div className="detail-hero-icon">
              <img src={logo} alt="Aarambh" style={{ height: '90px', objectFit: 'contain' }} />
            </div>
            <div className="detail-hero-info">
              {sanstha.verified && <span className="verified-badge-lg">✓ Verified Mandal</span>}
              <h1>{sanstha.name}</h1>
              {isDetailed && <p className="detail-tagline">{sanstha.tagline}</p>}
              <div className="detail-meta-row">
                <span>📍 {sanstha.area}, Valsad</span>
                <span>📅 Est. {sanstha.year}</span>
                <span>👥 {sanstha.members}+ Members</span>
              </div>
              <div className="detail-activities">
                {sanstha.activities.map((a) => (
                  <span key={a} className="activity-tag">{a}</span>
                ))}
              </div>
            </div>
            <div className="detail-hero-actions">
              <Link to="/donate" className="btn-primary">🙏 Donate to this Mandal</Link>
              <a href={`mailto:${sanstha.email || 'info@aarambh.org'}`} className="btn-outline">✉️ Contact</a>
            </div>
          </div>
        </div>
      </div>

      {isDetailed ? (
        <>
          {/* Stats */}
          <section className="detail-stats-section">
            <div className="container">
              <div className="detail-stats-grid">
                {sanstha.stats.map((s) => (
                  <div key={s.label} className="detail-stat card">
                    <span className="detail-stat-num">{s.value}</span>
                    <span className="detail-stat-label">{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* About + Contact */}
          <section className="detail-about-section">
            <div className="container detail-about-grid">
              <div className="detail-about-text">
                <div className="badge">About Us</div>
                <h2>Our Story</h2>
                {sanstha.about.split('\n\n').map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
              <div className="detail-contact-card card">
                <h3>Contact Information</h3>
                <ul className="detail-contact-list">
                  <li>
                    <span className="contact-icon">👤</span>
                    <div>
                      <span className="contact-label">President</span>
                      <span className="contact-value">{sanstha.president}</span>
                    </div>
                  </li>
                  <li>
                    <span className="contact-icon">📋</span>
                    <div>
                      <span className="contact-label">Secretary</span>
                      <span className="contact-value">{sanstha.secretary}</span>
                    </div>
                  </li>
                  <li>
                    <span className="contact-icon">📞</span>
                    <div>
                      <span className="contact-label">Phone</span>
                      <span className="contact-value">{sanstha.contact}</span>
                    </div>
                  </li>
                  <li>
                    <span className="contact-icon">✉️</span>
                    <div>
                      <span className="contact-label">Email</span>
                      <span className="contact-value">{sanstha.email}</span>
                    </div>
                  </li>
                  <li>
                    <span className="contact-icon">📍</span>
                    <div>
                      <span className="contact-label">Address</span>
                      <span className="contact-value">{sanstha.address}</span>
                    </div>
                  </li>
                </ul>
                <Link to="/donate" className="btn-primary" style={{ width: '100%', textAlign: 'center', marginTop: '20px', display: 'block' }}>
                  🙏 Donate Now
                </Link>
              </div>
            </div>
          </section>

          {/* Social Activities */}
          <section className="detail-activities-section">
            <div className="container">
              <div className="section-header">
                <div className="badge">What We Do</div>
                <h2>Social Activities</h2>
                <div className="divider">
                  <div className="divider-line" />
                  <span className="divider-icon">🌸</span>
                  <div className="divider-line right" />
                </div>
              </div>
              <div className="detail-activities-grid">
                {sanstha.socialActivities.map((act) => (
                  <div key={act.title} className="detail-activity-card card">
                    <div className="detail-activity-icon">{act.icon}</div>
                    <h3>{act.title}</h3>
                    <p>{act.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Gallery */}
          <section className="detail-gallery-section">
            <div className="container">
              <div className="section-header">
                <div className="badge">Memories</div>
                <h2>Photo Gallery</h2>
                <div className="divider">
                  <div className="divider-line" />
                  <span className="divider-icon">🌸</span>
                  <div className="divider-line right" />
                </div>
              </div>
              <div className="gallery-grid">
                {sanstha.gallery.map((emoji, i) => (
                  <div key={i} className="gallery-item">
                    <span>{emoji}</span>
                    <div className="gallery-overlay">Ganesh Utsav {sanstha.year + i}</div>
                  </div>
                ))}
              </div>
              <p className="gallery-note">📸 Photos coming soon — contact the mandal to contribute photos.</p>
            </div>
          </section>

          {/* Events */}
          <section className="detail-events-section">
            <div className="container">
              <div className="section-header">
                <div className="badge">Events</div>
                <h2>Our Events</h2>
                <div className="divider">
                  <div className="divider-line" />
                  <span className="divider-icon">🌸</span>
                  <div className="divider-line right" />
                </div>
              </div>
              <div className="detail-events-list">
                {sanstha.events.map((ev) => (
                  <div key={ev.title} className="detail-event-row card">
                    <span className={`event-dot ${ev.type}`} />
                    <div className="detail-event-info">
                      <h4>{ev.title}</h4>
                      <span>📅 {ev.date}</span>
                    </div>
                    <span className={`detail-event-status ${ev.type}`}>
                      {ev.type === 'upcoming' ? '🟢 Upcoming' : '✅ Completed'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </>
      ) : (
        /* Generic view for sanstha without detailed data */
        <section>
          <div className="container">
            <div className="generic-detail-grid">
              <div className="generic-info card">
                <h3>About {sanstha.name}</h3>
                <p>
                  {sanstha.name} is a registered Ganpati Mahotsav Mandal based in {sanstha.area}, Valsad district.
                  Established in {sanstha.year}, the mandal has {sanstha.members}+ active members and is dedicated to
                  celebrating Ganesh Chaturthi and serving the community through various social activities.
                </p>
                <div className="generic-stats">
                  <div className="generic-stat">
                    <span>{sanstha.members}+</span>
                    <label>Members</label>
                  </div>
                  <div className="generic-stat">
                    <span>{new Date().getFullYear() - sanstha.year}+</span>
                    <label>Years Active</label>
                  </div>
                  <div className="generic-stat">
                    <span>{sanstha.activities.length}</span>
                    <label>Activity Types</label>
                  </div>
                </div>
                <div className="detail-activities" style={{ marginTop: '16px' }}>
                  {sanstha.activities.map((a) => (
                    <span key={a} className="activity-tag">{a}</span>
                  ))}
                </div>
              </div>

              <div className="coming-soon-card card">
                <div style={{ marginBottom: '16px' }}>
                  <img src={logo} alt="Aarambh" style={{ height: '64px', objectFit: 'contain' }} />
                </div>
                <h3>Full Profile Coming Soon</h3>
                <p>
                  We are currently gathering detailed information for this mandal.
                  If you represent this mandal, please register or contact us to complete your profile.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
                  <Link to="/register" className="btn-primary" style={{ textAlign: 'center' }}>Complete Your Profile</Link>
                  <Link to="/contact" className="btn-outline" style={{ textAlign: 'center' }}>Contact Aarambh</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Bottom CTA */}
      <section className="detail-bottom-cta">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2>Support {sanstha.name}</h2>
          <p>Your donation directly supports this mandal's celebrations and social activities in {sanstha.area}.</p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '24px', flexWrap: 'wrap' }}>
            <Link to="/donate" className="btn-primary">🙏 Donate Now</Link>
            <Link to="/sanstha" className="btn-outline">← View All Mandal</Link>
          </div>
        </div>
      </section>

    </div>
  );
}
